import { StoreState } from '@store/index';

import { linearRegressionAnalysis, positiveAttitudeDetecting, captchaReader, stockAnalysis } from '@store/blog';
import { 
    movieDatabase, socialNetwork, holidayAccommodation, dietitian, healthcareInsurance, ABtestingPlatform, 
    jobManagementPlatform, golfWeb, golfIOs, musicListeningPlatformMvp, classifiedAdvertising, eLearning,
    authenticationiOS, financeApp
} from '@store/portfolio';

const initialState: StoreState = {
    transition: false,
    technologies: {
        portfolio: [],
        blog: [
            'Java2EE', 'Socket.io', 'Typescript', 'Bootstrap', 'PHP', 'Python', 'Angular', 'React', 'Postgres', 'MySQL', 'MSSQL'
        ],
    },
    portfolios: [ 
        movieDatabase, 
        socialNetwork, 
        holidayAccommodation, 
        dietitian, 
        healthcareInsurance, 
        ABtestingPlatform, 
        jobManagementPlatform, 
        golfWeb, 
        golfIOs, 
        musicListeningPlatformMvp,
        classifiedAdvertising, 
        eLearning, 
        authenticationiOS, 
        financeApp
    ],

    blogs: [ 
        positiveAttitudeDetecting, 
        linearRegressionAnalysis,
        captchaReader,
        stockAnalysis
    ],
}

export default initialState;



// WEBPACK FOOTER //
// ./src/store/initialState.tsx